(function () {
  function mountStoryCards(root) {
    const content = root.querySelector('[data-article-content][data-story-mount]');
    const template = root.querySelector('template[data-story-cards]');
    if (!content || !template) return;

    const headings = [...content.querySelectorAll('h2, h3')];
    const cards = [...template.content.querySelectorAll('[data-story-card]')];
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const observer = reduced ? null : new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });

    cards.forEach((card) => {
      const anchor = Number(card.dataset.anchor || 0);
      const target = headings[anchor - 1];
      if (!anchor || !target) return;
      target.insertAdjacentElement('afterend', card);
      if (reduced) card.classList.add('is-visible');
      else observer.observe(card);
    });
  }

  function init() {
    document.querySelectorAll('[data-story-root]').forEach(mountStoryCards);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
